<div class="guest-container flex justify-between items-center" [class.even]="even">
  <span class="weight-bold font-xs word-break">{{ guestName }}</span>
  @if (shouldDisplayGuestButtons) {
    <div class="buttons-section">
      @if (smartBadgingEnabled) {
        <a class="options-button info-button-margin" (click)="openBadge()">
          <mat-icon>info</mat-icon>
        </a>
      }
      <a class="options-button" (click)="sendMessage()">
        <mat-icon>textsms</mat-icon>
      </a>
      @if (isHost) {
        <a class="options-button" [matMenuTriggerFor]="menu">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10 18C10 19.1 10.9 20 12 20C13.1 20 14 19.1 14 18C14 16.9 13.1 16 12 16C10.9 16 10 16.9 10 18ZM10 6C10 7.1 10.9 8 12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6ZM10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10C10.9 10 10 10.9 10 12Z"
              fill="#333333"
            />
          </svg>
        </a>
      }
    </div>
  }
  <mat-menu #menu="matMenu" class="host-menu">
    <button mat-menu-item (click)="addHost()" [disabled]="isGuestHost || isGuestBanned || isEventOn">
      Make a Host
    </button>
    <button mat-menu-item (click)="removeFromRoom()" [disabled]="isGuestHost || isGuestBanned || isEventOn">
      Remove from room
    </button>
  </mat-menu>
</div>
